"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.syncQuantityWithPrice = exports.syncPriceWithQuantity = exports.mergeOpenOrders = exports.isMakerOrTaker = exports.getValuesFromDealValues = exports.getSubmitButtonText = exports.getQuantityForPrice = exports.getPriceForQuantity = exports.getOrdersBySide = exports.getOrderTotal = exports.getOrderPricePerUnit = exports.getOrderPrice = exports.getOrderNet = exports.getOrderLeverage = exports.getOrderFee = exports.getOrderBorrowingPower = exports.getMarketPrice = exports.getFuturesReferencePrice = exports.getFuturesOrderEntryPrice = void 0;
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _config = _interopRequireDefault(require("../config"));
var _makerTakerConstants = require("../constants/sendOrder/makerTakerConstants");
var _orderEntryFormConstants = require("../constants/sendOrder/orderEntryFormConstants");
var _decimalPlacesHelper = require("./decimalPlaces/decimalPlacesHelper");
var _numberFormatter = require("./numberFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/* This is reusable, project independent helper. Here shouldn't be store, or specific forms (except place order forms),
 only pure helpers */
var getQuantityForPrice = exports.getQuantityForPrice = function getQuantityForPrice(price) {
  var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var orders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var fill = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var side = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _orderEntryFormConstants.sellValue;
  var parsedPrice = new _bignumber["default"](price);
  var parsedPadding = new _bignumber["default"](padding);
  var paddedPrice = parsedPrice.minus(parsedPadding.times(parsedPrice));
  var remainingPrice = new _bignumber["default"](paddedPrice);
  var sum = new _bignumber["default"](0);
  var quantity = new _bignumber["default"](0);
  var lastPrice;
  var lastOrder;
  orders = _toConsumableArray(orders);
  if (side === _orderEntryFormConstants.buyValue) {
    orders.reverse();
  }
  if (orders.length) {
    orders.some(function (order) {
      var orderQty = new _bignumber["default"](order.Quantity);
      var orderPx = new _bignumber["default"](order.Price);
      var orderTotal = orderQty.times(orderPx);
      sum = sum.plus(orderTotal);
      if (sum.lt(paddedPrice)) {
        quantity = quantity.plus(orderQty);
      } else {
        var remainder = paddedPrice.minus(sum.minus(orderTotal));
        quantity = quantity.plus(remainder.div(orderPx));
        lastPrice = orderPx;
      }
      remainingPrice = remainingPrice.minus(orderTotal);
      lastOrder = order;
      return sum.gte(paddedPrice);
    });
  }
  if (fill && remainingPrice.gt(0) && orders.length) {
    quantity = quantity.plus(remainingPrice.div(lastOrder.Price));
    sum = paddedPrice;
  }
  if (sum.lt(paddedPrice)) {
    return {
      Price: parsedPrice,
      Quantity: '-'
    };
  }
  return {
    Price: parsedPrice,
    Quantity: quantity,
    LimitPrice: lastPrice || (lastOrder ? "".concat(lastOrder.Price) : '0')
  };
};
var getPriceForQuantity = exports.getPriceForQuantity = function getPriceForQuantity(quantity) {
  var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var orders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var fill = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var side = arguments.length > 4 ? arguments[4] : undefined;
  var parsedQuantity = new _bignumber["default"](quantity);
  var parsedPadding = new _bignumber["default"](padding);
  var paddedQty = parsedQuantity.plus(parsedPadding.times(quantity));
  var price = new _bignumber["default"](0);
  var remainingQty = new _bignumber["default"](paddedQty);
  var lastOrderPrice = new _bignumber["default"](0);
  var sortedOrders = _toConsumableArray(orders);
  if (side === _orderEntryFormConstants.buyValue) {
    sortedOrders.sort(function (a, b) {
      return a.Price - b.Price;
    });
  } else {
    sortedOrders.sort(function (a, b) {
      return b.Price - a.Price;
    });
  }
  sortedOrders.some(function (order) {
    var orderQuantity = new _bignumber["default"](order.Quantity);
    var orderPrice = new _bignumber["default"](order.Price);
    if (remainingQty.gt(orderQuantity)) {
      price = price.plus(orderQuantity.times(orderPrice));
    } else {
      price = price.plus(remainingQty.times(orderPrice));
    }
    remainingQty = remainingQty.minus(orderQuantity);
    lastOrderPrice = orderPrice;
    return remainingQty.lte(0);
  });
  if (fill && remainingQty.gt(0)) {
    price = price.plus(remainingQty.times(lastOrderPrice));
    remainingQty = 0;
  }
  if (remainingQty > 0) {
    return {
      Quantity: parsedQuantity,
      Price: '-',
      LimitPrice: lastOrderPrice
    };
  }
  return {
    Quantity: parsedQuantity,
    Price: price.toNumber(),
    LimitPrice: lastOrderPrice.toNumber()
  };
};

/**
 * @param {String} quantity
 * @param {Object} options
 * @param {Object} options.level2
 * @param {Array} options.level2.buy
 * @param {Array} options.level2.sell
 * @param {Object} options.selectedInstrument
 * @param {String} options.side
 */
var syncPriceWithQuantity = exports.syncPriceWithQuantity = function syncPriceWithQuantity(quantity, options) {
  var level2 = options.level2,
    selectedInstrument = options.selectedInstrument,
    side = options.side;
  var orders = getOrdersBySide(side, level2);
  var _config$OrderCalcBuff = _config["default"].OrderCalcBuffer,
    _config$OrderCalcBuff2 = _config$OrderCalcBuff === void 0 ? {} : _config$OrderCalcBuff,
    priceBuffer = _config$OrderCalcBuff2.priceBuffer;
  if (orders.length) {
    var priceForQuantity = getPriceForQuantity(quantity, priceBuffer, orders, true, side).Price;
    return (0, _numberFormatter.truncateToDecimals)(priceForQuantity, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement));
  }
  return 0;
};

/**
 * @param {String} price
 * @param {Object} options
 * @param {Object} options.level2
 * @param {Array} options.level2.buy
 * @param {Array} options.level2.sell
 * @param {Object} options.selectedInstrument
 * @param {String} options.side
 */
var syncQuantityWithPrice = exports.syncQuantityWithPrice = function syncQuantityWithPrice(price, options) {
  var level2 = options.level2,
    selectedInstrument = options.selectedInstrument,
    side = options.side;
  var orders = getOrdersBySide(side, level2);
  var _config$OrderCalcBuff3 = _config["default"].OrderCalcBuffer,
    _config$OrderCalcBuff4 = _config$OrderCalcBuff3 === void 0 ? {} : _config$OrderCalcBuff3,
    quantityBuffer = _config$OrderCalcBuff4.quantityBuffer;
  if (orders.length) {
    return (0, _numberFormatter.truncateToDecimals)(getQuantityForPrice(price, quantityBuffer, orders, true, side).Quantity, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.QuantityIncrement));
  }
  return 0;
};
var isMakerOrTaker = exports.isMakerOrTaker = function isMakerOrTaker(buyOrSell, price, bestBid, bestOffer, orderType) {
  var takerOrderTypes = [_orderEntryFormConstants.orderTypes.market.displayName, _orderEntryFormConstants.orderTypes.immediateOrCancel.displayName, _orderEntryFormConstants.orderTypes.stopMarket.displayName, _orderEntryFormConstants.orderTypes.trailingStopMarket.displayName];
  if (takerOrderTypes.includes(orderType)) {
    return _makerTakerConstants.takerValue;
  }
  if (buyOrSell === +_orderEntryFormConstants.buyValue) {
    return price < bestOffer || Number(bestOffer) === 0 ? _makerTakerConstants.makerValue : _makerTakerConstants.takerValue;
  } else if (buyOrSell === +_orderEntryFormConstants.sellValue) {
    return price > bestBid || Number(bestBid) === 0 ? _makerTakerConstants.makerValue : _makerTakerConstants.takerValue;
  }
  console.error("Incorrect buyOrSell value is provided: ".concat(buyOrSell));
  return _makerTakerConstants.takerValue;
};
var getOrderFee = exports.getOrderFee = function getOrderFee(form, products) {
  var symbolPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'beginning';
  var fee = form.fee;
  if (fee) {
    var _products$find;
    var OrderFee = fee.OrderFee,
      ProductId = fee.ProductId,
      FeeProductId = fee.FeeProductId;
    var feeProductId = FeeProductId ? FeeProductId : ProductId;
    var ProductSymbol = ((_products$find = products.find(function (product) {
      return product.ProductId === feeProductId;
    })) === null || _products$find === void 0 ? void 0 : _products$find.Product) || '';
    var formattedFee = (0, _numberFormatter.formatNumberToLocale)(OrderFee, ProductSymbol);
    if (symbolPosition === 'beginning') return "".concat(ProductSymbol, " ").concat(formattedFee);
    if (symbolPosition === 'end') return "".concat(formattedFee, " ").concat(ProductSymbol);
  }
  return '0';
};
var getOrderLeverage = exports.getOrderLeverage = function getOrderLeverage(form) {
  var fee = form.values.fee;
  if (fee) {
    return fee.Leverage || '—';
  }
  return '—';
};
var getOrderBorrowingPower = exports.getOrderBorrowingPower = function getOrderBorrowingPower(form, selectedInstrument) {
  var products = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var _form$values = form.values,
    fee = _form$values.fee,
    side = _form$values.side;
  if (fee && fee.BorrowingPower) {
    return fee.BorrowingPower;
  } else if (products.length > 0) {
    var productSymbol = side === _orderEntryFormConstants.buyValue ? selectedInstrument.Product2Symbol : selectedInstrument.Product1Symbol;
    var product = products.find(function (product) {
      return product.ProductSymbol === productSymbol;
    });
    var borrowingPower = product ? product.BorrowingPower : '0';
    return borrowingPower;
  }
  return '0';
};
var getOrderPricePerUnit = exports.getOrderPricePerUnit = function getOrderPricePerUnit(pricePerUnit, ProductSymbol, decimalPlaces) {
  if (!pricePerUnit) {
    return '0';
  }
  return "".concat((0, _numberFormatter.formatNumberToLocale)((0, _numberFormatter.parseNumberToLocale)(pricePerUnit), decimalPlaces), " per ").concat(ProductSymbol);
};
var getOrderTotal = exports.getOrderTotal = function getOrderTotal(form, instrument) {
  var totalAmount = form.values.totalAmount;
  var Product2Symbol = instrument.Product2Symbol;
  if (!totalAmount) {
    return '0';
  }
  return "".concat(Product2Symbol, " ").concat((0, _numberFormatter.formatNumberToLocale)(totalAmount, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement)));
};
var getOrderNet = exports.getOrderNet = function getOrderNet(formValues, instrument, orderTotal) {
  var displaySymbol = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var level1 = arguments.length > 4 ? arguments[4] : undefined;
  var instrumentLast = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var isMarginActive = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var decimalPlaces = arguments.length > 7 ? arguments[7] : undefined;
  var quantity = formValues.quantity,
    value = formValues.value,
    fee = formValues.fee,
    side = formValues.side,
    anchoredField = formValues.anchoredField;
  var PriceIncrement = instrument.PriceIncrement,
    QuantityIncrement = instrument.QuantityIncrement,
    Product1 = instrument.Product1,
    Product2 = instrument.Product2,
    Product1Symbol = instrument.Product1Symbol,
    Product2Symbol = instrument.Product2Symbol;
  var productDecimalPlaces = decimalPlaces !== undefined ? decimalPlaces : (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(side === _orderEntryFormConstants.buyValue ? QuantityIncrement : PriceIncrement);
  var productSymbol = side === _orderEntryFormConstants.buyValue ? Product1Symbol : Product2Symbol;
  var orderNet;
  if (!orderTotal || !quantity && !value) {
    return '0';
  }
  if (isMarginActive) {
    var _fee$FeeProductId;
    var feeProductId = (_fee$FeeProductId = fee.FeeProductId) !== null && _fee$FeeProductId !== void 0 ? _fee$FeeProductId : fee.ProductId;
    if (side === _orderEntryFormConstants.buyValue) {
      // Net Receiving is expressed in P1
      if (feeProductId === Product1) {
        // Fee is in P1, subtract directly
        orderNet = quantity - fee.OrderFee;
      } else {
        // Fee is in P2, convert to P1 using the market price
        var feeInP1 = fee.OrderFee / level1.BestOffer;
        orderNet = quantity - feeInP1;
      }
    } else {
      // Net Receiving is expressed in P2
      if (feeProductId === Product2) {
        // Fee is in P2, subtract directly
        orderNet = orderTotal - fee.OrderFee;
      } else {
        // Fee is in P1, convert to P2 using the market price
        var feeInP2 = fee.OrderFee * level1.BestBid;
        orderNet = orderTotal - feeInP2;
      }
    }
  } else {
    //spot account
    if (side === _orderEntryFormConstants.buyValue) {
      if (anchoredField === 'value') {
        // Over-ride for market-by-value.
        orderNet = value - (fee.ProductId === Product2 || fee.FeeProductId === Product2 ? fee.OrderFee : 0);
        orderNet = orderNet / level1.BestOffer;
      } else {
        orderNet = quantity - (fee.ProductId === Product1 || fee.FeeProductId === Product1 ? fee.OrderFee : 0);
      }
    } else {
      if (anchoredField === 'value') {
        orderNet = orderTotal - (fee.ProductId === Product2 || fee.FeeProductId === Product2 ? fee.OrderFee : 0);
      } else {
        orderNet = orderTotal - (fee.ProductId === Product2 || fee.FeeProductId === Product2 ? fee.OrderFee : 0);
      }
    }
  }
  if (Number.isNaN(orderNet) || !Number.isFinite(orderNet)) {
    return '—';
  }
  if (!displaySymbol) {
    return (0, _numberFormatter.formatNumberToLocale)(orderNet, productDecimalPlaces);
  }
  if (instrumentLast) {
    return "".concat((0, _numberFormatter.formatNumberToLocale)(orderNet, productDecimalPlaces), " ").concat(productSymbol);
  }
  return "".concat(productSymbol, " ").concat((0, _numberFormatter.formatNumberToLocale)(orderNet, productDecimalPlaces));
};
var getOrdersBySide = exports.getOrdersBySide = function getOrdersBySide(side, level2) {
  return side === _orderEntryFormConstants.buyValue ? level2.sell : level2.buy;
};
var getSubmitButtonText = exports.getSubmitButtonText = function getSubmitButtonText(side) {
  return side ? _orderEntryFormConstants.submitButtonTextOptions[side] : _orderEntryFormConstants.submitButtonTextOptions[_orderEntryFormConstants.buyValue];
};
var getMarketPrice = exports.getMarketPrice = function getMarketPrice(side, instrument, l1, decimalPlacesInt) {
  if (side && instrument && l1) {
    var marketPrice = (side === _orderEntryFormConstants.buyValue ? l1.BestOffer || l1.BestAsk : l1.BestBid) || 0;
    return (0, _numberFormatter.truncateToDecimals)(marketPrice, decimalPlacesInt);
  }
  return '0';
};
var mergeOpenOrders = exports.mergeOpenOrders = function mergeOpenOrders(orders) {
  var userOrders = _toConsumableArray(orders);
  var uniqOrders = [];
  userOrders.sort(function (a, b) {
    return a.Price.minus(b.Price);
  });
  userOrders.forEach(function (item) {
    var itemBefore = uniqOrders[uniqOrders.length - 1];
    if (itemBefore && item.Price.eq(itemBefore.Price)) {
      var mergeItem = _objectSpread(_objectSpread({}, item), {}, {
        DisplayQuantity: new _bignumber["default"](item.DisplayQuantity).plus(new _bignumber["default"](itemBefore.DisplayQuantity)),
        OrigQuantity: item.OrigQuantity.plus(itemBefore.OrigQuantity),
        OrderIds: [item.OrderId].concat(itemBefore.OrderIds)
      });
      uniqOrders.splice(uniqOrders.length - 1, 1, mergeItem);
    } else {
      uniqOrders.push(_objectSpread(_objectSpread({}, item), {}, {
        OrderIds: [item.OrderId]
      }));
    }
  });
  return uniqOrders;
};
var getValuesFromDealValues = exports.getValuesFromDealValues = function getValuesFromDealValues(dealValues, value) {
  var fieldToSearch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'price';
  return dealValues.find(function (i) {
    return parseFloat(i[fieldToSearch]) === parseFloat(value);
  }) || {};
};
var getOrderPrice = exports.getOrderPrice = function getOrderPrice(form, marketPrice) {
  if (form.values.orderType === _orderEntryFormConstants.orderTypes.limit.displayName) {
    return form.values.limitPrice;
  } else if (form.values.orderType === _orderEntryFormConstants.orderTypes.stopMarket.displayName) {
    return form.values.stopPrice;
  } else if (form.values.orderType === _orderEntryFormConstants.orderTypes.market.displayName) {
    return marketPrice;
  } else if (form.values.orderType === _orderEntryFormConstants.orderTypes.reserveOrder.displayName) {
    return form.values.limitPrice;
  } else if (form.values.orderType === _orderEntryFormConstants.orderTypes.stopLimit.displayName) {
    return form.values.stopPrice;
  }
  return '—';
};
var getFuturesOrderEntryPrice = exports.getFuturesOrderEntryPrice = function getFuturesOrderEntryPrice(form, marketPrice) {
  if (form.orderType === _orderEntryFormConstants.futuresOrderTypes.market.displayName) {
    return marketPrice;
  } else if (form.orderType === _orderEntryFormConstants.futuresOrderTypes.limit.displayName) {
    return form.limitPrice;
  } else if (form.orderType === _orderEntryFormConstants.futuresOrderTypes.conditional.displayName && form.priceOrderType === _orderEntryFormConstants.futuresOrderTypes.limit.displayName) {
    return form.price;
  } else if (form.orderType === _orderEntryFormConstants.futuresOrderTypes.conditional.displayName && form.priceOrderType === _orderEntryFormConstants.futuresOrderTypes.market.displayName) {
    return form.triggerPrice;
  }
  return 0;
};
var getFuturesReferencePrice = exports.getFuturesReferencePrice = function getFuturesReferencePrice(form, bestBidPrice) {
  if (form.orderType === _orderEntryFormConstants.futuresOrderTypes.market.displayName) {
    return bestBidPrice;
  } else if (form.orderType === _orderEntryFormConstants.futuresOrderTypes.limit.displayName) {
    return form.limitPrice;
  } else if (form.orderType === _orderEntryFormConstants.futuresOrderTypes.conditional.displayName && form.priceOrderType === _orderEntryFormConstants.futuresOrderTypes.limit.displayName) {
    return form.price; // form.price is limit price for conditional limit orders
  } else if (form.orderType === _orderEntryFormConstants.futuresOrderTypes.conditional.displayName) {
    return form.triggerPrice;
  }
  return 0;
};